<template>
    <div class="registration-tag-badge">
        <b-badge v-if="equipment.attested">
            {{(equipment.registration || {}).tagDisplay}}
        </b-badge>
    </div>
</template>

<script>
export default {
    name: "RegistrationTagBadge",
    props: {
        equipment: Object,
    },
}
</script>

<style scoped>

</style>
